module.exports = __webpack_public_path__ + "static/media/EG-P152.1bb91acc.jpg";